<template>
    <div class="filter-form">
        <header class="filter-form-header">
            <span>Filter {{property.filterFormLabel || property.label}}</span>
        </header>
        <div class="filter-form-body">
            <div class="d-flex align-items-center picker-container">
                <date-range-picker v-model="dateRange"
                                   @update="updateValues"
                                   :max-date="maxDate"
                                   :locale-data="{ format: 'yyyy-mm-dd' }"
                                   :auto-apply="false"
                                   :show-dropdowns="true"
                                   @toggle="checkOpenPicker"
                                   :class="{open: pickerOpen}"
                                   ref="picker">
                    <template v-slot:input>
                        <span v-if="canClearRange" class="range-label">{{ dateRange.startDate | date }} <strong>-</strong> {{ dateRange.endDate | date }}</span>
                        <span v-else class="range-label text-gray">Select a range...</span>
                    </template>
                </date-range-picker>
                <i class="clear-button gf gf-close" v-if="canClearRange" @click="clearRange"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import DateUtil from 'vue2-daterange-picker/src/components/date_util/native'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

    export default {
        name: "DateRanger",
        components: {DateRangePicker},
        methods: {
            focus() {
                this.$refs.picker.togglePicker(true);
                this.pickerOpen = true;
            },
            getValue() {
                const {startDate, endDate} = this.dateRange;
                if (startDate || endDate) {
                    return {range: {startDate, endDate}}
                }
                return null;
            },
            fillValue(payload) {
                if (payload) {
                    this.dateRange = payload.range;
                } else {
                    this.dateRange = {
                        startDate: null,
                        endDate: null,
                    };
                }
            },
            submit() {
                this.$emit('doSubmit', this.property.propertyKey, this.getValue());
            },
            updateValues() {
                this.submit();
                this.$emit('doClose', this.property.propertyKey);
            },
            clearRange() {
                this.dateRange = {
                    startDate: null,
                    endDate: null
                };
                this.submit();
            },
            checkOpenPicker(show) {
                this.pickerOpen = show;
            }
        },
        data() {
            return {
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                maxDate: new Date(),
                pickerOpen: false,
            }
        },
        props: {
            property: Object,
            parameters: Object,
        },
        computed: {
            canClearRange() {
                const {startDate, endDate} = this.dateRange;
                return startDate || endDate;
            }
        },
        filters: {
            date(d) {
                if (d) {
                    return DateUtil.format(d, 'yyyy-mm-dd');
                }
                return null;
            }
        }
    }
</script>

<style scoped lang="scss">
    .range-label {
        min-width: 170px;
        display: inline-block;
    }

    .picker-container {
        position: relative;

        &:hover {
            .clear-button {
                opacity: 0.5;
            }
        }

        .clear-button:hover {
            opacity: 1;
        }
    }

    .clear-button {
        position: absolute;
        top: 0;
        right: 3px;
        line-height: 22px;
        font-size: 0.86em;
        opacity: 0;
    }
</style>
